export const isEmailBitOn = (json: any, bitType : string) => {
    if ((json.license && json.license.length > 0)) {
      for (let i = 0; i < json.license.length; i++) {
        if (json.license[i].organizationDetail && json.license[i].organizationDetail.emailFeatureSettings && json.license[i].organizationDetail.emailFeatureSettings.length > 0) {
          for (let j = 0; j < json.license[i].organizationDetail.emailFeatureSettings.length; j++) {
            if (json.license[i].organizationDetail.emailFeatureSettings[j].emailFeatureName === bitType) {
              if (parseInt(json.license[i].organizationDetail.emailFeatureSettings[j].status)) {
                return true;
              }
            }
          }
        }
      }
    }
    return false;
  }